import { Spacing, Title } from '@vkontakte/vkui';
import React, { type ReactElement, type ReactNode, memo, useCallback, useEffect, useRef } from 'react';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';

import styles from './WhatsNewDialog.css';

interface WhatsNewMobileDialogProps {
    primaryButtonText: ReactNode;
    title: string | ReactElement;
    text?: string | ReactElement;
    content?: ReactElement | string;
    qaId?: string;
    imageUrl: string;

    onShow?(): void;

    onClose?(): void;

    onClick?(): void;
}

export const WhatsNewMobileDialog = memo<WhatsNewMobileDialogProps>(
    ({ title, content, qaId, primaryButtonText, imageUrl, onClose, onClick, onShow }) => {
        const scrollRef = useRef<HTMLDivElement>(null);

        const handleClose = useCallback(() => {
            onClose?.();
        }, [onClose]);

        const handleOk = useCallback(() => {
            onClick?.();
            onClose?.();
        }, [onClose]);

        useEffect(() => {
            onShow?.();
        }, [onShow]);

        return (
            <MobileDialog
                id={qaId || 'whatsnew-mob'}
                onClose={handleClose}
                topmost
                closeOnDimmerClick
                scrollRef={scrollRef}
                mod="base"
                contextPadding="zero"
                closeMode="darkAndRound"
                isRebrandingQuotaLanding
            >
                <div ref={scrollRef} className={styles.rootMobile}>
                    <div className={styles.imageContainer}>
                        <img src={imageUrl} className={styles.image} />
                    </div>
                    <Spacing size={24} />
                    <Title level="1" className={styles.title}>
                        {title}
                    </Title>
                    <div className={styles.contentWrapper}>{content}</div>
                    <div className={styles.buttonWrapper}>
                        <Button theme="vk" primary onClick={handleOk} sizeMode={ButtonSizeMode.extraBig}>
                            {primaryButtonText}
                        </Button>
                    </div>
                </div>
            </MobileDialog>
        );
    }
);

WhatsNewMobileDialog.displayName = 'WhatsNewMobileDialog';
